import { render, staticRenderFns } from "./advance_table.vue?vue&type=template&id=52cdd012&scoped=true"
import script from "./advance_table.vue?vue&type=script&lang=js"
export * from "./advance_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cdd012",
  null
  
)

export default component.exports